import { render, staticRenderFns } from "./ThirdPartyDescription.vue?vue&type=template&id=2eaee6ad&"
import script from "./ThirdPartyDescription.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports